<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link v-if="p_idPerfil == 18 || p_idPerfil == 20" to="/tramite-asignados">Trámites</router-link>
            <router-link v-else to="/tramite">Trámites</router-link>
            > Trámite N.° <b>{{ p_idTramite }}</b>
          </div>
        </div>
<!--		
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
          >
            help
          </span>
        </div>
-->		
      </div>
    </div>
<!--
    <Modal v-model:modelValue="showModalHelp">
      <AyudaTramiteForm />
    </Modal>
-->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="row">
          <!-- Columna izquierda -->
          <div class="col-9">
            <div class="row">
              <div class="col-2">
                <label for="idTramite" class="form-label fw-bold"
                  >&nbsp;&nbsp;Número</label
                >
              </div>
              <div class="col-1">
                <span id="idTramite">{{ datoTramite.idTramite }}</span>
              </div>

              <div class="col-1">
                <label for="servicioNombre" class="form-label fw-bold"
                  >Servicio</label
                >
              </div>
              <div class="col-3">
                <span id="servicioNombre">{{
                  datoTramite.servicioNombre
                }}</span>
              </div>

              <div class="col-2">
                <label for="nombreComercial" class="form-label fw-bold"
                  >Prestador</label
                >
              </div>
              <div class="col-3">
                <span id="nombreComercial">{{
                  datoTramite.nombreComercial
                }}</span>
              </div>
            </div>
          </div>

          <!-- Columna derecha -->
          <div class="col-3 text-end">
            <button
              class="btn btn-outline-secondary d-inline-flex align-items-center gap-1"
              @click.prevent="mostrarOcultarBloque"
              style="
                padding-top: 0.1rem;
                padding-bottom: 0.1rem;
                padding-left: 0.5rem;
                padding-right: 0.5rem;
              "
            >
              <span class="material-icons" style="font-size: 1.1rem">
                {{
                  mostrarBloque ? "remove_circle_outline" : "add_circle_outline"
                }}
              </span>
              {{ mostrarBloque ? "Más información" : "Menos información" }}
            </button>
          </div>
        </div>

        <div v-if="mostrarBloque" class="mb-3">
          <!-- Modal de Tramite -->
          <div class="mb-3">
            <div class="row">
              <!-- Panel izquierdo -->
              <div class="col-9">
                <form>
                  <div class="modal-body">
                    <div class="mb-3">
                      <div class="row">
                        <div class="col-2">
                          <label for="fechaDesde" class="form-label fw-bold"
                            >Fecha desde</label
                          >
                        </div>
                        <div class="col-2">
                          <span id="fechaDesde">{{
                            getFormattedDate(datoTramite.fechaDesde)
                          }}</span>
                        </div>
                        <div class="col-2">
                          <label for="fechaHasta" class="form-label fw-bold"
                            >Fecha hasta</label
                          >
                        </div>
                        <div class="col-2">
                          <span id="fechaHasta">{{
                            getFormattedDate(datoTramite.fechaHasta)
                          }}</span>
                        </div>
                        <div class="col-2">
                          <label for="fechaReg" class="form-label fw-bold"
                            >Fecha reg.</label
                          >
                        </div>
                        <div class="col-2">
                          <span id="fechaReg">{{
                            getFormattedDate(datoTramite.fechaReg)
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="row">
                        <div class="col-2">
                          <label for="tipoAsignacion" class="form-label fw-bold"
                            >Asignado a</label
                          >
                        </div>
                        <div class="col-2">
                          <span id="tipoAsignacion">
                            {{
                              datoTramite.tipoAsignacion === "U"
                                ? "USUARIO"
                                : datoTramite.tipoAsignacion === "T"
                                ? "TODOS"
                                : "DESCONOCIDO"
                            }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="row">
                        <div class="col-2">
                          <label for="estadoTramite" class="form-label fw-bold"
                            >Estado</label
                          >
                        </div>
                        <div class="col-2">
                          <span id="estadoTramite">{{
                            datoTramite.estadoTramite
                          }}</span>
                        </div>
                        <div class="col-2">
                          <label for="estadoTramite" class="form-label fw-bold"
                            >Inicial</label
                          >
                        </div>
                        <div class="col-2">
                          <span id="inicial">{{
                            datoTramite.inicial === 1 ? 'SI' : 'NO'
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="row">
                        <div class="col-2">
                          <label for="descripcion" class="form-label fw-bold"
                            >Descripción</label
                          >
                        </div>
                        <div class="col-10">
                          <span
                            id="descripcion"
                            style="text-transform: uppercase"
                            >{{ datoTramite.descripcion }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <!-- Panel derecho -->
              <div class="col-3">
                <br />
                <button
                  v-if="supervisor"
                  type="button"
                  class="mb-2 btn btn-outline-primary w-100"
                  @click.prevent="autorizaciones"
                  title="Solicitudes para modificación y carga de archivos"
                  :disabled="datoTramite.estadoTramite == 'ENVIADO'"
                >
                  Solicitudes
                </button>

                <!-- <button
                  v-if="supervisor"
                  type="button"
                  class="mb-2 btn btn-outline-primary w-100"
                  @click.prevent="reporteArchivosNuevos"
                  title="Actualizar"
                  :disabled="datoTramite.estadoTramite == 'ENVIADO'"
                >
                  Archivos nuevos
                </button> -->

                <button
                  v-if="supervisor"
                  class="mb-2 btn btn-outline-success w-100"
                  @click="cambiarTipoAsignacion"
                  title="Cambiar tipo de asignación"
                  :disabled="datoTramite.estadoTramite != 'EN PROCESO'"
                >
                  Cambiar asignación
                </button>

                <button
                  v-if="supervisor && datoTramite.estadoTramite == 'FINALIZADO'"
                  class="mb-2 btn btn-outline-success w-100"
                  @click="cambiarEstado"
                  title="Cambiar tipo de asignación"
                >
                  En Proceso
                </button>

                <button
                  v-if="supervisor"
                  class="mb-2 btn btn-outline-success w-100"
                  @click="finalizarTramite"
                  title="Actualizar"
                  :disabled="datoTramite.estadoTramite == 'ENVIADO'"
                >
                  Finalizar Trámite
                </button>
<button
  v-if="datoTramite.inicial===0"
  type="button"
  class="mb-2 btn btn-outline-success w-100"
  @click="exportarParaFinanciador"
  :disabled="exportando"
  title="Exportar archivos para el financiador (aplana reexpediciones)"
>
  <span class="material-symbols-outlined align-middle" style="font-size:16px">folder_zip</span>
  {{ exportando ? 'Generando...' : 'Exportar para financiador' }}
</button>			
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
    </div>

<!-- Tabs -->
<div class="container">

  <!-- Tabs Operativos -->
  <div class="mb-3">
<!--  
    <h6 class="fw-bold text-primary">Operativos</h6>
-->	
    <div class="nav nav-tabs">
      <button
        class="nav-link"
        :class="{ active: showTable === 'planillas' }"
        @click="showTable = 'planillas'"
      >
        <span class="material-symbols-outlined me-1">docs</span>
        Atenciones Médicas
      </button>
      <button
        class="nav-link"
        :class="{ active: showTable === 'planillasPendientes' }"
        @click="showTable = 'planillasPendientes'"
      >
        <span class="material-symbols-outlined me-1">draft</span>
        Pendientes
      </button>
      <button
        class="nav-link"
        :class="{ active: showTable === 'planillasRevisadas' }"
        @click="showTable = 'planillasRevisadas'"
      >
        <span class="material-symbols-outlined me-1">task</span>
        Revisadas
      </button>
      <button
        class="nav-link"
        :class="{ active: showTable === 'planillasAnuladas' }"
        @click="showTable = 'planillasAnuladas'"
      >
        <span class="material-symbols-outlined me-1">task</span>
        Anuladas
      </button>
      <button
        class="nav-link"
        :class="{ active: showTable === 'planillasManuales' }"
        @click="showTable = 'planillasManuales'"
      >
        <span class="material-symbols-outlined me-1">docs</span>
        Manuales
      </button>
      <button
        class="nav-link"
        :class="{ active: showTable === 'planillasFiltros' }"
        @click="showTable = 'planillasFiltros'"
      >
        <span class="material-symbols-outlined me-1">document_search</span>
        Buscar
      </button>
    </div>
  </div>

  <!-- Tabs Supervisores -->
  <div v-if="supervisor || verReportes > 0" class="mb-3">
<!--  
    <h6 class="fw-bold text-danger">Supervisores</h6>
-->	
    <div class="nav nav-tabs">
      <button
        v-if="asignarDoc"
        class="nav-link"
        @click="showTable = 'documental'"
        :class="{ 'active-tab': showTable === 'documental' }"
      >
        <span class="material-symbols-outlined"> person </span>
        Asignar Gestor Documental
      </button>
      <button
        v-if="asignarAud"
        class="nav-link"
        @click="showTable = 'medico'"
        :class="{ 'active-tab': showTable === 'medico' }"
      >
        <span class="material-symbols-outlined"> person </span>
        Asignar Médico Auditor
      </button>	
      <button
        v-if="supervisor"
        class="nav-link"
        :class="{ active: showTable === 'bitacoraTra' }"
        @click="showTable = 'bitacoraTra'"
      >
        <span class="material-symbols-outlined me-1">calendar_month</span>
        Bitácora del Trámite
      </button>

      <button
        v-if="supervisor || verReportes > 0"
        class="nav-link"
        :class="{ active: showTable === 'reportes' }"
        @click="showTable = 'reportes'"
      >
        <span class="material-symbols-outlined me-1">description</span>
        Reportes
      </button>
<!--
      <button
        class="nav-link"
        :class="{ active: showTable === 'cargaPlanillas' }"
        @click="showTable = 'cargaPlanillas'"
      >
        <span class="material-symbols-outlined me-1">upload_file</span>
        Carga Planillas Asegurador
      </button>
-->
<!--
      <button
        class="nav-link"
        :class="{ active: showTable === 'novedades' }"
        @click="showTable = 'novedades'"
      >
        <span class="material-symbols-outlined me-1">warning</span>
        Novedades
      </button>
-->	  
      <button
        v-if="supervisor"
        class="nav-link"
        :class="{ active: showTable === 'controles' }"
        @click="showTable = 'controles'"
      >
        <span class="material-symbols-outlined me-1">warning</span>
        Controles
      </button>
      <button
        v-if="supervisor"
        class="nav-link"
        :class="{ active: showTable === 'mapeoElemento' }"
        @click="showTable = 'mapeoElemento'"
      >
        <span class="material-symbols-outlined me-1">calendar_month</span>
        Mapeo de códigos
      </button>
    </div>
  </div>

  <!-- Tabs GD Revisión -->
<!--  
  <div v-if="p_idUsuario==21 || p_idUsuario==26" class="mb-3">
    <div class="nav nav-tabs">

      <button
        class="nav-link"
        :class="{ active: showTable === 'reportes' }"
        @click="showTable = 'reportes'"
      >
        <span class="material-symbols-outlined me-1">description</span>
        Reportes
      </button>

    </div>
  </div>
-->

</div>


    <!-- Contenido dinámico según la pestaña seleccionada -->
    <!--
    <div v-if="showTable === 'cargaamb'">
      <CargaAmb :p_idTramite="p_idTramite"></CargaAmb>
    </div>
    -->
    <div v-if="showTable === 'medico'">
      <CargaAsignacion
        :p_idTramite="Number(p_idTramite)"
        :p_tipo="'med'"
      ></CargaAsignacion>
    </div>
    <div v-if="showTable === 'documental'">
      <CargaAsignacion
        :p_idTramite="Number(p_idTramite)"
        :p_tipo="'doc'"
      ></CargaAsignacion>
    </div>
    <div v-if="showTable === 'planillas'">
      <Planilla :p_tramite="datoTramite" :p_tipoConsulta="'TODAS'" ref="planillasRef"></Planilla>
    </div>
    <div v-if="showTable === 'planillasPendientes'">
      <Planilla :p_tramite="datoTramite" :p_tipoConsulta="'PENDIENTES'" ref="pendientesRef"></Planilla>
    </div>
    <div v-if="showTable === 'planillasRevisadas'">
      <Planilla :p_tramite="datoTramite" :p_tipoConsulta="'REVISADAS'" ref="revisadasRef"></Planilla>
    </div>
    <div v-if="showTable === 'planillasAnuladas'">
      <Planilla :p_tramite="datoTramite" :p_tipoConsulta="'ANULADAS'" ref="anuladasRef"></Planilla>
    </div>
    <div v-if="showTable === 'planillasFiltros'">
      <ConsultaPlanillas :p_tramite="datoTramite" :p_tipoConsulta="'FILTROS'" ref="filtrosRef"></ConsultaPlanillas>
    </div>
    <div v-if="showTable === 'planillasManuales'">
      <Planilla :p_tramite="datoTramite" :p_tipoConsulta="'MANUALES'" ref="manualesRef"></Planilla>
    </div>

    <div v-if="showTable === 'bitacoraTra'">
      <BitacoraTra :p_idTramite="Number(p_idTramite)"></BitacoraTra>
    </div>
<div v-if="showTable === 'reportes' && datoTramite.estadoTramite">
  <hr />
  <TramiteReportes
    :idTramite="Number(datoTramite.idTramite)"
    :idServicio="Number(datoTramite.idServicio)"
    :estadoTramite="datoTramite.estadoTramite"
    :idPerfil="Number(p_idPerfil)"
    :verReportes="Number(verReportes)"
    :supervisor="supervisor"
  />
</div>
    <div v-if="showTable === 'cargaPlanillas'">
      <hr />
      <!-- Cargar archivo de datos -->
      <div class="upload-container">
        <!-- Texto introductorio -->
        <div class="mb-3">
          <p>
            Esta funcionalidad permite cargar desde un archivo <b>CSV</b>, con
            el formato establecido, los datos correspondientes a las atenciones
            médicas asociadas al trámite. Asegúrate de que el archivo cumpla con
            las especificaciones requeridas antes de cargarlo.
          </p>
        </div>

        <!-- Formulario de carga -->
        <form @submit.prevent="uploadFile">
          <div class="row align-items-center">
            <div class="col-3">
              <label for="archivoDatos"
                ><b>Seleccionar Archivo de datos:</b></label
              >
            </div>
            <div class="col-6">
              <input
                type="file"
                id="archivoDatos"
                name="archivoDatos"
                class="form-control"
                @change="handleFileUpload"
                accept=".csv"
                required
                aria-describedby="archivoDatosHelp"
              />
              <small id="archivoDatosHelp" class="form-text text-muted">
                Selecciona un archivo CSV con los datos a cargar.
              </small>
            </div>
            <div class="col-3 text-end">
              <button
                type="submit"
                class="btn btn-outline-success d-flex align-items-center"
              >
                <span
                  class="material-symbols-outlined"
                  style="font-size: 32px; cursor: pointer"
                  >upload_file</span
                >
                <b>Cargar archivo de datos</b>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
<!--	
    <div v-if="showTable === 'novedades'">
      <TramiteNovedades :p_idTramite="Number(p_idTramite)" />
    </div>
-->
    <div v-if="showTable === 'controles'">
      <Controles
        :p_idTramite="Number(p_idTramite)"
        :p_idPrestador="Number(datoTramite.idPrestador)"
        :p_inicial="Number(datoTramite.inicial)"
      >
      </Controles>
    </div>

    <div v-if="showTable === 'mapeoElemento'">
      <MapeoElemento
        :p_idTramite="Number(p_idTramite)"
        :p_idPrestador="Number(datoTramite.idPrestador)"
      >
      </MapeoElemento>
    </div>

    <Footer />
  </div>
</template>

<script>
import config from '@/config';
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import TramiteReportes from "@/components/TramiteReportes.vue";

import api from "@/services/api";
import axios from "axios";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
//import { currentDateTimeISO } from "@/modules/dateUtils";
import Planilla from "@/views/forms/Planilla.vue";
import CargaAsignacion from "@/views/forms/CargaAsignacion.vue";
import BitacoraTra from "@/views/forms/BitacoraTra.vue";
//import TramiteNovedades from "@/views/reportes/TramiteNovedades.vue";
import ConsultaPlanillas from "@/views/reportes/ConsultaPlanillas.vue";
import Controles from "@/views/reportes/Controles.vue";
import MapeoElemento from "@/views/forms/MapeoElemento.vue";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import Swal from "sweetalert2";

export default {
  components: {
    Layout,
    Footer,
    Planilla,
    CargaAsignacion,
    BitacoraTra,
//    TramiteNovedades,
    ConsultaPlanillas,
    Controles,
    MapeoElemento,
    TramiteReportes
  },
  data() {
    return {
      tramites: [],
      datoTramite: {},
      datoBitacoraTra: {},
      nombreBusqueda: "",
      titulo: "",
      modalWindow: true,
      showModalHelp: false,
      p_idTramite: 0,
      p_idCarga: 0,
      p_idPerfil: 0,
      verReportes: 0,
      showTable: "",
      prestadors: [],
      servicios: [],
      archivoDatos: null, // Archivo CSV seleccionado
      archivosPlanillas: [], // Arreglo para múltiples archivos
      paginaActual: 1, // Definir paginaActual si se usa
      message: "", // Mensaje de éxito o error
      messageClass: "", // Clase de Bootstrap para el mensaje
      mensaje: "",
      success: false,
      mostrarBloque: true,
      opcionesBloque01: [
        {
          nombre: "Observaciones de Auditoría Médica",
          accion: this.obsAuditoriaMedicaPDF,
          id: 1,
        },
        {
          nombre: "Observaciones de Gestión Documental",
          accion: this.obsGestionDocumentalPDF,
          id: 2,
        },
        {
          nombre: "Consolidado de Planillas",
          accion: this.planillasConsolidadoPDF,
          id: 3,
        },
        {
          nombre: "Detallado de Planillas",
          accion: this.planillasDetalladoPDF,
          id: 4,
        },
      ],
      opcionesBloque02: [
        {
          nombre: "Observaciones y Respuestas de Auditoría Médica",
          accion: this.obsResAuditoriaMedicaPDF,
          id: 1,
        },
        {
          nombre: "Observaciones y Respuestas de Gestión Documental",
          accion: this.obsResGestionDocumentalPDF,
          id: 2,
        },
      ],
    };
  },
  computed: {
    deshabilitarBoton01() {
      return (
        this.datoTramite.estadoTramite !== "ENVIADO" &&
        this.datoTramite.estadoTramite !== "ENVIADO"
      );
    },
    deshabilitarBoton02() {
      return this.datoTramite.estadoTramite !== "ENVIADO";
    },
    asignarAud() {
      return (
        (this.p_idPerfil == 16 || this.p_idPerfil == 17) &&
        (this.datoTramite.estadoTramite === "RECIBIDO" ||
          this.datoTramite.estadoTramite === "EN PROCESO" ||
          this.datoTramite.estadoTramite === "PLANILLAJE")
      );
    },
    asignarDoc() {
      return (
        (this.p_idPerfil == 16 || this.p_idPerfil == 19) &&
        (this.datoTramite.estadoTramite === "RECIBIDO" ||
          this.datoTramite.estadoTramite === "EN PROCESO" ||
          this.datoTramite.estadoTramite === "PLANILLAJE")
      );
    },
    supervisor() {
      return (this.p_idPerfil == 1 || this.p_idPerfil == 17 || this.p_idPerfil == 19);
    },
    periodo() {
      if (!this.datoTramite?.fechaDesde) return "";

      const fecha = new Date(this.datoTramite.fechaDesde);

      return fecha
        .toLocaleDateString("es-ES", { year: "numeric", month: "long" })
        .toUpperCase();
    },
  },
  async mounted() {
    this.p_idTramite = this.$route.params.p_idtramite;
    if (this.$route.query.tab) {
      this.showTable = this.$route.query.tab;
    }
    this.p_idPerfil  = window.sessionStorage.getItem("idPerfil");
    this.p_idUsuario = window.sessionStorage.getItem("idUsuario");
    this.verReportes = window.sessionStorage.getItem("verReportes");
    await this.getData();
	await this.obtenerIdCarga();
	this.verificarEstado();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
// Agrega listener para mensajes de la popup
    window.addEventListener('message', this.handlePopupMessage);
  },
  beforeUnmount() {
    // Remueve el listener para evitar memory leaks
    window.removeEventListener('message', this.handlePopupMessage);
    document.title = `Allikamay`;
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
async getData() {
  const response = await api.get(`/vwtramites/${this.p_idTramite}`);
  this.datoTramite = response.data;
  this.datoTramite.fechaDesde = dateFormat.getFormattedDateISOtramiteform(this.datoTramite.fechaDesde);
  this.datoTramite.fechaHasta = dateFormat.getFormattedDateISOtramiteform(this.datoTramite.fechaHasta);
  sessionStorage.setItem("datosTramite", 
    this.datoTramite.nombreComercial + " - " +
    this.datoTramite.servicioNombre + " - " +
    this.periodo
  );
  document.title = `Allikamay - Trámite Nº: ${this.p_idTramite}`;
},
    async obtenerIdCarga() {
      try {
        const response = await api.get(
          `/vwcargas/carga-mes-tramite`,
          { params: { idTramite: this.p_idTramite } }
        );

        this.p_idCarga = response.data.idCarga ?? null;
      } catch (error) {
        console.error('Error al obtener idCarga:', error);
      }
    },
    validarForm() {
      const requiredFields = [
        "idPrestador",
        "idServicio",
        "fechaDesde",
        "fechaHasta",
        "descripcion",
      ];
      const requiredFieldsText = [
        "idPrestador",
        "idServicio",
        "fechaDesde",
        "fechaHasta",
        "descripcion",
      ];
      return validarForm(this.datoTramite, requiredFields, requiredFieldsText);
    },

    async actualizarTramite(mensajeExito) {
      try {
        await api.post(
          `/tramites/${window.sessionStorage.getItem(
            "idUsuario"
          )}`,
          this.datoTramite
        );
        Swal.fire("Correcto", mensajeExito, "success");
      } catch (error) {
        Swal.fire(
          "Error",
          "Hubo un problema al actualizar el trámite. Intenta de nuevo.",
          "error"
        );
      }
    },
/*
    async finalizarTramite() {
      this.datoTramite.estadoTramite = "FINALIZADO";
      this.datoTramite.fechaFinAud = currentDateTimeISO(new Date());
      await this.actualizarTramite("El trámite se ha finalizado exitosamente.");
    },
*/
    async finalizarTramite() {
      try {
        const response = await api.put(`/vwtramites/${this.datoTramite.idTramite}/finalizar`);
        this.datoTramite.estadoTramite = "FINALIZADO";
        Swal.fire({
          icon: 'success',
          title: 'Trámite finalizado',
          text: response.data,
        });
      } catch (error) {
if (
  error.response &&
  error.response.data &&
  error.response.data.message === "Error: No todas las planillas cumplen con los requisitos. Revise los datos."
) {
Swal.fire({
  icon: 'error',
  title: 'Las atenciones médicas no cumplen las condiciones requeridas.',
  html: `
    <div style="text-align: justify;">
      Asegúrese de que:<br>
      1. Todas las atenciones médicas estén revisadas y finalizadas por Auditoría Médica (AM).<br>
      2. Todas las atenciones médicas estén revisadas y finalizadas por Gestión Documental (GD).
    </div>
  `,
});
}
         else {
          Swal.fire({
            icon: 'error',
            title: 'Error al finalizar el trámite',
            text: error.response.data.message,
          });
        }
      }
    },
    async cambiarTipoAsignacion() {
      this.datoTramite.tipoAsignacion =
        this.datoTramite.tipoAsignacion === "U" ? "T" : "U";
      await this.actualizarTramite(
        "Tipo de asignación actualizada exitosamente."
      );
    },

    async cambiarEstado() {
      this.datoTramite.estadoTramite =
        this.datoTramite.estadoTramite === "FINALIZADO"
          ? "EN PROCESO"
          : "FINALIZADO";
      await this.actualizarTramite("Estado actualizado exitosamente.");
    },

    autorizaciones() {
        this.$router.push(
          "/autorizacion-tramite/" + this.p_idTramite
        );
    },
    reporteArchivosNuevos(idAtencion) {
      if (idAtencion != null) {
        this.$router.push(
          "/tramites-archivos-nuevos/" +
            this.datoTramite.idTramite +
            "/" +
            this.datoTramite.fechaIniAud +
            "/" +
            this.datoTramite.fechaFinAud
        );
      }
    },
    verBitacora() {
      this.$router.push("/bitacora-tramite/" + this.datoTramite.idTramite);
    },
    descargarZIP() {
      axios({
        method: "get",
        url:
          config.apiBaseUrl+"/vwarchivospla/descargar/" +
          this.datoTramite.idTramite,
        responseType: "blob", // Importante para manejar archivos binarios
      })
        .then((response) => {
          // Crear un enlace para descargar el archivo
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "archivos_tramite_" + this.datoTramite.idTramite + ".zip"
          ); // Nombre del archivo
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          if (error.response && error.response.data.message) {
            // Mostrar mensaje de error con SweetAlert2
            Swal.fire({
              icon: "error",
              title: "Error al descargar el archivo",
              text: error.response.data.message, // Mensaje del error
            });
            console.error("Error al descargar el archivo: 1", error.response);
            console.error(
              "Error al descargar el archivo: 2",
              error.response.data.message
            );
          } else {
Swal.fire({
  icon: 'error',
  title: 'Las atenciones médicas no cumplen las condiciones requeridas.',
  html: `
    <div style="text-align: justify;">
      Asegúrese de que:<br>
      1. Todas las atenciones médicas estén revisadas y finalizadas por Auditoría Médica (AM).<br>
      2. Todas las atenciones médicas estén revisadas y finalizadas por Gestión Documental (GD).
    </div>
  `,
});
          }
        });
    },
/*	
    abrirReporte(tipo, tipoUsuario) {
      const url = `${config.apiBaseUrl}/reportes/pdf/${tipo}/${this.p_idTramite}?identificador02=${this.p_idCarga}&tipo=${tipoUsuario}`;
      window.open(url, "_blank");
    },
*/
abrirReporte(tipo, tipoUsuario) {
  let url = `${config.apiBaseUrl}/reportes/pdf/${tipo}/${this.p_idTramite}`;
  const params = new URLSearchParams();

  if (this.p_idCarga !== null && this.p_idCarga !== undefined) {
    params.append('identificador02', this.p_idCarga);
  }
  params.append('tipo', tipoUsuario);

  window.open(`${url}?${params.toString()}`, "_blank");
},
    obsAuditoriaMedicaPDF() {
      this.abrirReporte(4, 'M');
    },
    obsGestionDocumentalPDF() {
      this.abrirReporte(5, 'D');
    },
    planillasConsolidadoPDF() {
      this.abrirReporte(10, null);
    },
    planillasDetalladoPDF() {
      this.abrirReporte(11, null);
    },
    obsResAuditoriaMedicaPDF() {
      this.abrirReporte(8, 'M');
    },
    obsResGestionDocumentalPDF() {
      this.abrirReporte(9, 'D');
    },
async descargarCSV() {
  try {
    const response = await api.get("/vw-reporte-finan/csv-por-tramite", {
      params: { idTramite: this.p_idTramite },
      responseType: 'blob' // Muy importante para manejar archivos
    });

    const blob = new Blob([response.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = "reporte_financiero.csv"; // o toma de header si lo deseas
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
  if (error.response && error.response.data && error.response.data.message) {
    // Mostrar mensaje de error recibido desde el backend
    Swal.fire({
      icon: "error",
      title: "Error al descargar el archivo",
      text: error.response.data.message,
    });
  } else {
    // Mensaje personalizado en caso de que no haya un mensaje específico
    Swal.fire({
      icon: 'error',
      title: 'Las atenciones médicas no cumplen las condiciones requeridas.',
      html: `
        <div style="text-align: justify;">
          Asegúrese de que:<br>
          1. Todas las atenciones médicas estén revisadas y finalizadas por Auditoría Médica (AM).<br>
          2. Todas las atenciones médicas estén revisadas y finalizadas por Gestión Documental (GD).
        </div>
      `,
    });
  }
}
},
    // Captura el archivo seleccionado para archivoDatos
    handleFileUpload(event) {
      this.archivoDatos = event.target.files[0];
    },
    // Enviar archivoDatos al servidor
    async uploadFile() {
      if (!this.archivoDatos) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se ha seleccionado ningún archivo para cargar.",
          showConfirmButton: true,
        });
        return;
      }

      // Obtener la fecha de modificación del archivo
      const fechaModificacion = this.archivoDatos.lastModified; // Timestamp en milisegundos

      const formData = new FormData();
      formData.append("idTramite", this.p_idTramite);
      formData.append("idUsuario", this.p_idUsuario);
      formData.append("fechaModificacion", fechaModificacion);
      formData.append("file", this.archivoDatos);

      try {
        Swal.fire({
          title: "Procesando...",
          text: "Por favor, espera mientras se cargan los archivos.",
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading(); // Muestra el indicador de carga
          },
        });

        const response = await api.post(
          `/cargafinans/upload`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        Swal.close();

        await Swal.fire({
          icon: "success",
          title: "Archivos cargados correctamente",
          html: response.data.message,
          showConfirmButton: true,
        }).then(() => {
          // Este bloque se ejecuta después de que el usuario presiona "OK"
          // Limpiar el input y el estado
          this.archivoDatos = null;
          document.getElementById("archivoDatos").value = "";
          // Recargar la página
          window.location.reload();
        });
      } catch (error) {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Hubo un error al cargar los archivos. Inténtalo de nuevo.";
        await Swal.fire({
          icon: "error",
          title: "Error",
          html: `Hubo un error al cargar los archivos. Inténtalo de nuevo. ${errorMessage}`,
          showConfirmButton: true,
        }).then(() => {
          // Este bloque se ejecuta después de que el usuario presiona "OK"
          // Recargar la página
          window.location.reload();
        });
      }
    },

    async enviarObservaciones(tipo) {
      try {
        Swal.fire({
          title: "Procesando...",
          text: "Por favor, espera mientras se genera el reporte.",
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading(); // Muestra el indicador de carga
          },
        });
        // Enviar correo
        const response = await api.post(
            '/vwtramites/sendObservaciones', null, {
                params: {
                    tipo: tipo,
                    idTramite: this.p_idTramite,
                    idUsuario: this.p_idUsuario,
                }
            }
        );
        Swal.close();
if (response.status === 200) {
  const mensaje = response.data;
  const esPrimeraVez = mensaje === "Correo con reporte de observaciones enviado.";

  Swal.fire(
    esPrimeraVez ? "Éxito" : "Atención",
    mensaje,
    esPrimeraVez ? "success" : "info"
  );
}
      } catch (error) {
        // Captura y muestra los errores en la consola
        if (error.response) {
          // La solicitud fue realizada y el servidor respondió con un código de estado
          // que no está en el rango de 2xx
          console.log("Error de respuesta:", error.response);
        } else if (error.request) {
          // La solicitud fue hecha pero no se recibió respuesta
          console.log("Error de solicitud:", error.request);
        } else {
          // Algo sucedió al configurar la solicitud
          console.log(
            "Error en la configuración de la solicitud:",
            error.message
          );
        }

        Swal.fire(
          "Error",
          "Ocurrió un problema al procesar la solicitud. Intenta de nuevo.",
          "error"
        );
      }
    },
    verificarEstado() {
      if (this.datoTramite.estadoTramite == "ENVIADO" && this.p_idPerfil == 17) {
        Swal.fire({
          title: 'El trámite no está recibido',
          text: '¿Deseas recibirlo ahora?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí',
          cancelButtonText: 'No',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            this.recibirTramite(this.p_idTramite)
          }
        })
      }
    },
    async recibirTramite() {
      try {
        const response = await api.put(
          `/tramites/recibir-tramite/${this.p_idTramite}`,
          null,
          {
            params: {
              idUsuario: this.p_idUsuario,
              estadoTramiteActual: "ENVIADO",
            },
          }
        );

        // SweetAlert2 para éxito
        Swal.fire({
          title: "Éxito",
          text: response.data,
          icon: "success",
          confirmButtonText: "OK",
        });
        this.datoTramite.estadoTramite = "RECIBIDO";
      } catch (error) {
        console.error("Error al actualizar el trámite:", error);

        // SweetAlert2 para errores
        Swal.fire({
          title: "Error",
          text: error.response?.data || "Error al actualizar el trámite",
          icon: "error",
          confirmButtonText: "Cerrar",
        });
      }
    },
handlePopupMessage(event) {
  if (event.origin !== window.location.origin) return;
  const data = event.data;
  if (data.action === 'refreshAndSwitchTab') {
    this.showTable = data.tab;
    const refMap = {
      planillas: 'planillasRef', planillasPendientes: 'pendientesRef',
      planillasRevisadas: 'revisadasRef', planillasAnuladas: 'anuladasRef',
      planillasManuales: 'manualesRef', planillasFiltros: 'filtrosRef',
    };
    this.$nextTick(() => {
      const comp = this.$refs[refMap[data.tab]];
      if (comp && typeof comp.refrescar === 'function') comp.refrescar();
    });
  }
},

async exportarParaFinanciador() {
  this.exportando = true;

  // Modal de carga bloqueado (sin botón de cerrar, sin cerrar por click afuera o ESC)
  Swal.fire({
    title: 'Generando export...',
    html: 'Esto puede tardar unos minutos dependiendo del tamaño del trámite.<br>Por favor espere.',
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  try {
    const response = await api.get(`/justificaciones/export-financiador/${this.p_idTramite}`, {
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `tramite_${this.p_idTramite}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    Swal.fire({
      icon: 'success',
      title: 'Export generado',
      text: 'El archivo se descargó correctamente.',
      confirmButtonColor: '#0d6efd',
    });
  } catch (err) {
    console.error(err);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'No se pudo generar el export',
      confirmButtonColor: '#dc3545',
    });
  } finally {
    this.exportando = false;
  }
},

  },
};
</script>

<style src="@/assets/css/tabs.css" scoped></style>
<style scoped>
.upload-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90%;
  margin: 10px auto;
  padding: 15px;
  border: 2px solid #ccc;
  border-radius: 12px;
  background-color: #f7f9fc;
}

.row.align-items-center {
  display: flex;
  align-items: center;
}

.text-end {
  text-align: right;
}
</style>
<style scoped>
.btn {
  font-size: 16px;
  padding: 10px 20px;
}
</style>
<style scoped>
.reports-container {
  max-width: 100%;
  margin: auto;
  text-align: center;
}
.list-group-item {
  padding: 10px;
}
</style>
<style scoped>
.glow-naranja:hover {
  box-shadow: 0 0 12px rgba(255, 165, 0, 0.9), 0 0 20px rgba(255, 165, 0, 0.7);
}
.glow-negro:hover {
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.9), 0 0 20px rgba(0, 0, 0, 0.7);
}
</style>
<style scoped>
  .control-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding: 10px;
  }

  .control-label {
    font-weight: bold;
  }
</style>

<style scoped>
.nav-tabs .nav-link.active {
  background-color: #0d6efd; /* Azul Bootstrap */
  color: #fff !important;   /* Texto blanco */
  border-color: #0d6efd #0d6efd #fff; /* Mantener bordes limpios */
}		
</style>